import styled from "styled-components";

export const Container = styled.section`
    padding: 8rem 2rem;

    background: ${({ theme }) => theme.colors.background};
`;

export const Wrapper = styled.div`
    max-width: 1200px;
    margin: 0 auto;
`;

export const Header = styled.div`
    max-width: 700px;

    margin: 0 auto 5rem;

    text-align: center;
`;

export const Badge = styled.span`
    display: inline-flex;
    align-items: center;

    padding: .5rem 1rem;

    border: 1px solid rgba(127, 191, 208, .25);
    border-radius: 999px;

    background: rgba(127, 191, 208, .08);

    color: ${({ theme }) => theme.colors.primary};

    font-size: .9rem;
    font-weight: 600;

    margin-bottom: 1.5rem;
`;

export const Title = styled.h2`
    font-size: clamp(2rem, 5vw, 3rem);
    font-weight: 700;

    color: ${({ theme }) => theme.colors.white};

    margin-bottom: 1.5rem;
`;

export const Description = styled.p`
    color: rgba(255, 255, 255, .7);

    font-size: 1.1rem;
    line-height: 1.8;
`;

export const Grid = styled.div`
    display: grid;

    grid-template-columns: repeat(2, 1fr);

    gap: 2rem;

    @media (max-width: 992px) {
        grid-template-columns: 1fr;
    }
`;